import styles from "./InfoPage.module.scss";
import Nav from "@/components/Header/Nav/Nav";
import Footer from "@/components/Footer/Footer";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getSiteConfig } from "@/config/siteConfigs";
import { Helmet } from "react-helmet-async";

const PaymentFailed = () => {
  const { t } = useTranslation("pages");
  const siteConfig = getSiteConfig();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Helmet>
        <title>{t("paymentFailed.meta.title")}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <Nav />
      <h2 className={`sectionContainer ${styles.title}`}>
        {t("paymentFailed.title")}
      </h2>
      <div className="container sectionContainer sectionContainerWhite">
        <p className={styles.infoPageText}>
          {t("paymentFailed.message")}
          <br />
          {t("paymentFailed.checkDetails")}
        </p>

        <p className={styles.infoPageText}>
          {t("paymentFailed.contactSupport")}
          <br />
          Telefon: {siteConfig.contact.phone}
          <br />
          E-Mail: {siteConfig.contact.email}
        </p>
      </div>
      <Footer />
    </div>
  );
};

export default PaymentFailed;
